<template>
    <b-form-radio :value="value" :key="text" size="lg" class="mx-1 mcq-proposal">
        {{ text }}
    </b-form-radio>
</template>

<script>
export default {
    props: {
        value: Number,
        text: String,
    }
}
</script>

<style>
[type='radio'] {
    display: none; 
}
.mcq-proposal {
    word-break: break-word;
}
</style>